import React, { useEffect, useState } from "react";
import { fetchProjects } from "../../lib/global";
import Image from "next/image";

function DronerMobileReference({ droner }: { droner: any }) {
  const [projects, setProjects] = useState<any[]>([]);

  useEffect(() => {
    fetchProjects(droner?.uid).then((projects) => setProjects(projects));
  }, [droner?.uid, projects]);

  return (
    <>
      <div className="compare__images">
        {projects.map((projects, i) => {
          return (
            <Image
              key={i}
              src={projects?.images[0]}
              alt=""
              width="137"
              height="100"
              loading="lazy"
            />
          );
        })}
      </div>
    </>
  );
}

export default DronerMobileReference;
